// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sidebar_wrapper__1w42w","overlay":"sidebar_overlay__3m38a","top":"sidebar_top__3AS-M","icon":"sidebar_icon__1ojQn"};